import script from "./DatabaseView.vue?vue&type=script&setup=true&lang=js"
export * from "./DatabaseView.vue?vue&type=script&setup=true&lang=js"

import "./DatabaseView.vue?vue&type=style&index=0&id=529c47e6&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-529c47e6"]])

export default __exports__